import { Card, Tag } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SeasonData } from 'type/seasonType';

export interface SeasonCardProps {
  season: SeasonData;
}

export const SeasonCard: React.FC<SeasonCardProps> = ({ season }) => {
  const navigate = useNavigate();
  const title = season.title || season.slug;

  return (
    <Card
      hoverable
      onClick={() => navigate(`/vendor/download/${season.id}`)}
      style={{ width: 280 }}
    >
      <Card.Meta
        title={title}
        description={
          <div style={{ marginTop: 8 }}>
            {season.season_number != null && <Tag>Season {season.season_number}</Tag>}
            {season.status && <Tag color="blue">{season.status}</Tag>}
          </div>
        }
      />
    </Card>
  );
};
